export default __webpack_public_path__ + "static/media/icon_municipalTaxes.65221713.svg";